module.exports = __webpack_public_path__ + "static/media/facebook.1141a0c4.svg";